import { Route, Routes } from 'react-router-dom';

import { allowedModules, MODULES } from 'common/constants/index';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import storageWrapper from 'common/loginUtils/storage-wrapper';

import AIModels from 'features/AIModels/AIModels';
import AIModelsLayout from 'features/AIModels/AIModelsLayout';
import ClusterReviewLanding from 'features/AIModels/ClusterReviewlandingPage/ClusterReviewLanding';
import ControlDeDuplicationLandingPage from 'features/AIModels/ControlDeDuplicationLandingPage/ControlDeDuplicationLandingPage';
import ControlDeDuplicationLandingPageLayout from 'features/AIModels/ControlDeDuplicationLandingPage/ControlDeDuplicationLandingPageLayout';
import AiSimulationLayout from 'features/AiSimulation/AiSimulationLayout';
import RegulationSelectionDetails from 'features/AiSimulation/Components/RegulationTable/RegulationSelectionDetail';
import ControlObjective from 'features/AiSimulation/ControlObjective/ControlObjective';
import ControlQualityGrammerCheck from 'features/AiSimulation/ControlQualityGrammerCheck/ControlQualityGrammerCheck';
import ControlQualityWrapper from 'features/AiSimulation/ControlQualityGrammerCheck/ControlQualityWrapper';
import ControlStatement from 'features/AiSimulation/ControlStatement/ControlStatement';
import ControlTestScripts from 'features/AiSimulation/ControlTestScripts/ControlTestScripts';
import ObligationAndControl from 'features/AiSimulation/ObligationAndControl/ObligationAndControl';
import ObligationToPolicy from 'features/AiSimulation/ObligationToPolicy/ObligationToPolicy';
import PlainEnglishSummary from 'features/AiSimulation/PlainEnglishSummary/PlainEnglishSummary';
import RegulationSummary from 'features/AiSimulation/RegulationSummary/RegulationSummary';
import RiskStatement from 'features/AiSimulation/RiskStatement/RiskStatement';
import SimulationArena from 'features/AiSimulation/SimulationArena/SimulationArena';
import SimulationRegulationGenerate from 'features/AiSimulation/SimulationRegulationGenerate/SimulationRegulationGenerate';
import RegulationChange from 'features/ChangeEngine/RegulationChange/RegulationChange';
import RegulationChangeLayout from 'features/ChangeEngine/RegulationChange/RegulationChangeLayout';
import RiskChange from 'features/ChangeEngine/RiskChange';
import DataIngestion from 'features/DataIngestion/DataIngestion';
import UploadParser from 'features/DataIngestion/UploadParser/UploadParser';
import GRCModifiedchanges from 'features/GRC/GRCModifiedChanges';
import Dashboard from 'features/HomePage/Dashboard';
import DashboardLayout from 'features/HomePage/DashboardLayout';
import DownloadFile from 'features/HomePage/DownloadFile/DownloadFile';
import HorizonDetailLayout from 'features/HorizonScanning/HorizonDetailLayout/HorizonDetailLayout';
import HorizonScanningPage from 'features/HorizonScanning/HorizonScanning';
import HorizonScanningLayout from 'features/HorizonScanning/HorizonScanningLayout';
import MappingEngine from 'features/MappingEngine/MappingEngine';
import RegInvCardsLandingPage from 'features/RegulationInventory/Components/RegInvCardsLandingPage/RegInvCardsLandingPage';
import RegulationHorizon from 'features/RegulationInventory/Horizon/RegulationHorizon';
import MappingDetail from 'features/RegulationInventory/Mapping/RegulationInventoryMappingDetail';
import GroupAssessmentDetails from 'features/RegulationInventory/RegulationGroup/GroupAssessmentDetails';
import GroupReviewDetails from 'features/RegulationInventory/RegulationGroup/GroupReviewDetails';
import RegulationInventoryDetails from 'features/RegulationInventory/RegulationInventoryDetails/RegulationInventoryDetails';
import RegulationInventoryLandingPage from 'features/RegulationInventory/RegulationInventoryLandingPage/RegulationInventoryLandingPage';
import RegulationInventoryLayout from 'features/RegulationInventory/RegulationInventoryLayout';
import RegulationInventorySummary from 'features/RegulationInventory/Summary/RegulationInventorySummary';
import ReportingLibrary from 'features/Reporting/ReportingLibrary';
import ReportingLibraryDetail from 'features/Reporting/ReportingLibraryDetail';
import ReportingLibraryLayout from 'features/Reporting/ReportingLibraryLayout';
import EntityDetailLayout from 'features/RiskProfile/Taxonomy/EntityDetailLayout';
import RiskRefTaxonomy from 'features/RiskProfile/Taxonomy/RiskReferenceTaxonomy/RiskRefTaxonomy';
import TaxonomyLayout from 'features/RiskProfile/Taxonomy/TaxonomyLayout';
import RiskQuantification from 'features/RiskQuantification/RiskQuantification';
import Settings from 'features/Settings/Settings';
import TestHubLandingPage from 'features/TestMonitoring/TestHubLandingPage/TestHubLandingPage';
import TestMonitoring from 'features/TestMonitoring/TestMonitoring';
import TestMonitoringLayout from 'features/TestMonitoring/TestMonitoringLayout';
import TestScriptHubLandingPage from 'features/TestMonitoring/TestScriptHubLandingPage/TestScriptHubLandingPage';

import PrivateRoute from './PrivateRoute';

const {
	parent,
	entityId,
	riskChange,
	regulationChange,
	mappingEngine,
	dataIngestion,
	riskQuantification,
	grcModifiedChanges,
	testing,
	testingHub,
	testScriptHub,
	aimodels,
	controlDeDuplication,
	deDuplicationClusterReview,
	regulationInventory,
	overView,
	regulatoryApplicability,
	regulatoryGroupReview,
	regulatoryGroupAssessment,
	regulationSummaryAssessment,
	regulationMappingAssessment,
	groupId,
	regulationMappingRegId,
	simulationArena,
	obligationToPolicy,
	obligationAndControl,
	plainEnglishSummary,
	regulationSummary,
	riskStatement,
	controlObjective,
	controlStatement,
	controlTestScripts,
	controlQualityGrammerCheck,
	controlQuality,
	simulationType,
	generate,
	subPartId,
	reporting,
	reportingLibraryDetail,
	reportId,
	horizonScanning,
	horizonScanningDetail,
	management,
	prcInventory,
	downloadFile,
	uploadParser,
} = rrcpDashboardRoutes;

const {
	HOME,
	RISK_CHANGE,
	REGULATION_CHANGE,
	MAPPING_ENGINE,
	DATA_INGESTION,
	RISK_QUANTIFICATION,
	MODIFIED_CHANGES,
	TESTING_AND_MONITORING,
	AI_MODELS,
	REQUIREMENT_INVENTORY,
	AI_SIMULATION_AND_EXPERIMENTATION,
	REPORTING_DATABASE,
	HORIZON_SCAN_AND_ALERTS,
	MANAGEMENT,
	RISK_REFERENCE_TAXONOMY,
} = MODULES;

const RRCPDashboardWrapper = () => (
	<div>
		<Routes>
			<Route
				element={<PrivateRoute allowedModules={[HOME, ...allowedModules]} />}
			>
				<Route path={parent} element={<DashboardLayout />}>
					<Route
						element={<Dashboard />}
						path=":approvals?/:status?/:entityType?/:entityId?/:entityName?/:count?/"
					/>
					<Route
						path={`${downloadFile}/:fileName/:type`}
						element={<DownloadFile />}
					/>
				</Route>
			</Route>
			<Route
				element={<PrivateRoute allowedModules={[RISK_REFERENCE_TAXONOMY]} />}
			>
				<Route path={prcInventory} element={<TaxonomyLayout />}>
					<Route index element={<RiskRefTaxonomy />} />
					<Route
						path={`${entityId}/:entityType?/:auditId?/:auditKey?/`}
						element={<EntityDetailLayout />}
					/>
				</Route>
			</Route>
			<Route element={<PrivateRoute allowedModules={[RISK_CHANGE]} />}>
				<Route path={riskChange} element={<RiskChange />} />
			</Route>
			<Route element={<PrivateRoute allowedModules={[REGULATION_CHANGE]} />}>
				<Route path={regulationChange} element={<RegulationChangeLayout />}>
					<Route index element={<RegulationChange />} />
				</Route>
			</Route>
			<Route element={<PrivateRoute allowedModules={[MAPPING_ENGINE]} />}>
				<Route path={mappingEngine} element={<MappingEngine />} />
			</Route>

			<Route
				path={dataIngestion}
				element={<PrivateRoute allowedModules={[DATA_INGESTION]} />}
			>
				<Route index element={<DataIngestion />} />

				<Route path={uploadParser} element={<UploadParser />} />
			</Route>

			<Route element={<PrivateRoute allowedModules={[RISK_QUANTIFICATION]} />}>
				<Route path={riskQuantification} element={<RiskQuantification />} />
			</Route>

			<Route element={<PrivateRoute allowedModules={[MODIFIED_CHANGES]} />}>
				<Route path={grcModifiedChanges} element={<GRCModifiedchanges />} />
			</Route>

			<Route
				element={<PrivateRoute allowedModules={[TESTING_AND_MONITORING]} />}
			>
				<Route path={testing} element={<TestMonitoringLayout />}>
					<Route index element={<TestMonitoring />} />
					<Route index path={testingHub} element={<TestHubLandingPage />} />
					<Route
						index
						path={testScriptHub}
						element={<TestScriptHubLandingPage />}
					/>
				</Route>
			</Route>
			<Route element={<PrivateRoute allowedModules={[AI_MODELS]} />}>
				<Route path={aimodels} element={<AIModelsLayout />}>
					<Route index element={<AIModels />} />
					<Route
						path={controlDeDuplication}
						element={<ControlDeDuplicationLandingPageLayout />}
					>
						<Route index element={<ControlDeDuplicationLandingPage />} />
						<Route
							path={deDuplicationClusterReview}
							element={<ClusterReviewLanding />}
						/>
					</Route>
				</Route>
			</Route>

			<Route
				element={<PrivateRoute allowedModules={[REQUIREMENT_INVENTORY]} />}
			>
				<Route
					path={regulationInventory}
					element={<RegulationInventoryLayout />}
				>
					<Route
						path={`${overView}/${regulatoryApplicability}/${subPartId}`}
						element={
							<RegulationInventoryDetails storageWrapper={storageWrapper} />
						}
					/>
					<Route
						path={`${overView}/${regulatoryGroupReview}/${groupId}`}
						element={<GroupReviewDetails storageWrapper={storageWrapper} />}
					/>
					<Route
						path={`${overView}/${regulatoryGroupAssessment}/${subPartId}`}
						element={<GroupAssessmentDetails storageWrapper={storageWrapper} />}
					/>

					<Route
						path={`${overView}/${regulationSummaryAssessment}/${groupId}`}
						element={
							<RegulationInventorySummary storageWrapper={storageWrapper} />
						}
					/>

					<Route
						path={`${overView}/${regulationMappingAssessment}/${groupId}`}
						element={<MappingDetail storageWrapper={storageWrapper} />}
					/>

					<Route
						path={`${overView}/${regulationMappingAssessment}/${groupId}/${regulationMappingRegId}`}
						element={<RegulationHorizon storageWrapper={storageWrapper} />}
					/>

					<Route
						path={`${overView}`}
						element={<RegulationInventoryLandingPage />}
					/>
					<Route index element={<RegInvCardsLandingPage />} />
				</Route>
			</Route>
			<Route
				element={
					<PrivateRoute allowedModules={[AI_SIMULATION_AND_EXPERIMENTATION]} />
				}
			>
				<Route path={simulationArena} element={<AiSimulationLayout />}>
					<Route index element={<SimulationArena />} />
					<Route path={obligationToPolicy} element={<ObligationToPolicy />} />
					<Route
						path={obligationAndControl}
						element={<ObligationAndControl />}
					/>
					<Route path={plainEnglishSummary} element={<PlainEnglishSummary />} />
					<Route path={regulationSummary} element={<RegulationSummary />} />
					<Route path={riskStatement} element={<RiskStatement />} />

					<Route path={controlObjective} element={<ControlObjective />} />

					<Route path={controlStatement} element={<ControlStatement />} />

					<Route path={controlTestScripts} element={<ControlTestScripts />} />

					<Route
						path={controlQualityGrammerCheck}
						element={<ControlQualityGrammerCheck />}
					/>
					<Route
						path={`${controlQualityGrammerCheck}/${controlQuality}`}
						element={<ControlQualityWrapper />}
					/>
					<Route
						path={`${simulationType}/${generate}/${subPartId}`}
						element={<RegulationSelectionDetails />}
					/>
					<Route
						path={`${simulationType}/${generate}`}
						element={<SimulationRegulationGenerate />}
					/>
				</Route>
			</Route>
			<Route element={<PrivateRoute allowedModules={[REPORTING_DATABASE]} />}>
				<Route path={reporting} element={<ReportingLibraryLayout />}>
					<Route index element={<ReportingLibrary />} />
					<Route
						path={reportingLibraryDetail}
						element={<ReportingLibraryDetail />}
					/>
					<Route
						path={`${reportingLibraryDetail}/${reportId}`}
						element={<ReportingLibraryDetail />}
					/>
				</Route>
			</Route>

			<Route
				element={<PrivateRoute allowedModules={[HORIZON_SCAN_AND_ALERTS]} />}
			>
				<Route path={horizonScanning} element={<HorizonScanningLayout />}>
					<Route index element={<HorizonScanningPage />} />
					<Route
						path={horizonScanningDetail}
						element={<HorizonDetailLayout />}
					/>

					<Route
						path={`${horizonScanningDetail}/${subPartId}`}
						element={<HorizonDetailLayout />}
					/>
				</Route>
			</Route>

			<Route element={<PrivateRoute allowedModules={[MANAGEMENT]} />}>
				<Route path={management} element={<Settings />} />
			</Route>
		</Routes>
	</div>
);
export default RRCPDashboardWrapper;
